/*
 * Copyright (c) Nexign, JSC, 2022-2023.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @author Ilya Baranchikov
 * @version 1.25.1
 * @since 1.19.0
 */

import { useDispatch } from 'react-redux';

import { ELogBusinessEventName, ELogBusinessEventType, logBusinessEvent } from '@/main/modules/logging';
import { formatNumberToPhone } from '@components/common/PhoneMask/formatNumberToPhone';
import { CLIENT_ID, RoutePath } from '@routes/constants/routesConstants';

import type { ITableLinkProps } from './types';

export const useTableMsisdnCell = (id: number, value: string, fromConstructor = false): ITableLinkProps => {
    const dispatch = useDispatch();

    const onClick = () => {
        dispatch(
            logBusinessEvent({
                eventName: ELogBusinessEventName.USER_SUBSCRIBER_CARD,
                type: ELogBusinessEventType.common,
            }),
        );
    };

    return {
        isExternalUrl: false,
        linkState: { fromConstructor },
        url: RoutePath.subscriberId.replace(CLIENT_ID, id?.toString()),
        children: value ? formatNumberToPhone(value) : null,
        noValue: !id || !value,
        onClick,
    };
};
